<template>
  <v-form ref="form" v-bind="this.$attrs">
    <div class="mb-2">
      <span class="error--text">*</span> Tài khoản được xử lý theo thông tin tên giáo viên được cung cấp ban đầu. Nếu họ
      tên giáo viên bị thay đổi, nội dung tài khoản cũng bị thay đổi theo.
    </div>
    <v-text-field outlined :value="teacherUsername || teacher.code" label="Tài khoản" dense disabled></v-text-field>
    <div>
      <div class="mb-2">
        <span class="error--text">*</span> Bỏ trống các ô nhập dưới đây nếu không thay đổi mật khẩu
      </div>
      <v-text-field
        v-if="role.type === 'teacher'"
        v-model="oldPassword"
        label="Mật khẩu cũ"
        :append-icon="show ? 'visibility' : 'visibility_off'"
        :rules="isChangePassword ? [$rules.required] : []"
        :type="show ? 'text' : 'password'"
        @click:append="show = !show"
        outlined
        dense
      ></v-text-field>
      <v-text-field
        v-model="password"
        label="Mật khẩu mới"
        :append-icon="show ? 'visibility' : 'visibility_off'"
        :rules="isChangePassword ? [$rules.nospace, $rules.required, $rules.minLength(6)] : []"
        :type="show ? 'text' : 'password'"
        @click:append="show = !show"
        outlined
        dense
      ></v-text-field>
      <v-text-field
        v-model="password2"
        label="Nhập lại mật khẩu"
        :append-icon="show2 ? 'visibility' : 'visibility_off'"
        :rules="
          isChangePassword
            ? [$rules.nospace, $rules.required, $rules.minLength(6), $rules.passInputAgain(password2, password)]
            : []
        "
        :type="show2 ? 'text' : 'password'"
        @click:append="show2 = !show2"
        outlined
        dense
      ></v-text-field>
    </div>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    teacher: Object,
    formState: Boolean,
    teacherUsername: String
  },
  data: () => ({
    oldPassword: '',
    password: '',
    password2: '',
    show: false,
    show2: false
  }),
  computed: {
    ...mapGetters('auth', ['profile', 'role']),

    isChangePassword() {
      return !!this.password
    }
  },

  created() {},
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      return {
        userId: this.profile.user,
        oldPassword: this.oldPassword,
        newPassword: this.password
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  watch: {
    formState(formState) {
      if (!formState) {
        this.oldPassword = ''
        this.password = ''
        this.password2 = ''
      }
    }
  }
}
</script>

<style scoped></style>
